export const CREATE_USER = 'CREATE_USER'
export const UPDATE_USER = 'UPDATE_USER'
export const DELETE_USER = 'DELETE_USER'
export const SEARCH_USER = 'SEARCH_USER'
export const SET_USER_SEARCH_CRITERIA = 'SET_USER_SEARCH_CRITERIA'
export const CLEAR_MODAL_VALUES = 'CLEAR_MODAL_VALUES'
export const SET_MODAL_VALUES = 'SET_MODAL_VALUES'
export const GET_MAX_ID = 'GET_MAX_ID'
